export interface DropdownProps {
  triggerSelector: string;
  isActive?: boolean;
  width?: string;
}
